<template>
<main id="profile" v-if="!loading">
    
    
    
    <article>
        
        <div class="find-us">
            <p>Locate on <a href="https://goo.gl/maps/pCHYcGmDwpe4pZNE9" target="_blank">Google Maps</a></p>
        </div>
        
        <div class="contact-info">
            <div class="address">
                <p>
                    Vesterbrogade 80b<br>
                    1620 Copenhagen<br>
                    Denmark
                </p>
            </div>
            <div class="links">
                <a href="tel:+4533254500">Tel. +45 3325 4500</a><br>
                <a href="mailto:info@e-types.com">info@e-types.com</a>    
            </div>
        </div>
        
        <div class="contact-persons">
            <p>For new business inqueries:</p>
            <ul class="contacts">
                <li class="contact" v-for="(contact, index) in contactPeople" :key="index">
                    <p>
                        {{contact.name}}<br>
                        {{contact.title}}<br>
                        <a :href="`phone:${contact.phone}`">{{contact.phone}}</a><br>
                        <a :href="`mailto:${contact.email}`">{{contact.email}}</a>
                    </p>
                </li>
            </ul>
        </div>
        
        <div class="career-internship">
            <p>Regarding career or internship opportunities, please contact:</p>
            <p><a href="mailto:career@e-types.com">career@e-types.com</a> / <a href="mailto:intern@e-types.com">intern@e-types.com</a></p>
        </div>

        <div class="etypes-employees">
            <h2>People (A-Z)</h2>
            <ul class="employees">
                <li class="employee" v-for="(employee, index) in etypesEmployees" :key="index">
                    <p>
                        {{employee.name}}<br>
                        {{employee.title}}<br>
                        <a :href="`phone:${employee.phone}`">{{employee.phone}}</a><br>
                        <a :href="`mailto:${employee.email}`">{{employee.email}}</a>
                    </p>
                </li>
            </ul>
        </div>
        
        <div class="playtype-employees">
            <h2>Playtype (A-Z)</h2>
            <ul class="employees">
                <li class="employee" v-for="(employee, index) in playtypeEmployees" :key="index">
                    <p>
                        {{employee.name}}<br>
                        {{employee.title}}<br>
                        <a :href="`phone:${employee.phone}`">{{employee.phone}}</a><br>
                        <a :href="`mailto:${employee.email}`">{{employee.email}}</a>
                    </p>
                </li>
            </ul>
        </div>
        
        <div class="administration-employees">
            <h2>Administration (A-Z)</h2>
            <ul class="employees">
                <li class="employee" v-for="(employee, index) in administrationEmployees" :key="index">
                    <p>
                        {{employee.name}}<br>
                        {{employee.title}}<br>
                        <a :href="`phone:${employee.phone}`">{{employee.phone}}</a><br>
                        <a :href="`mailto:${employee.email}`">{{employee.email}}</a>
                    </p>
                </li>
            </ul>
        </div>

    </article>

    <Footer />

    <SecondaryNavigation :text="this.$router.currentRoute.name" :showCloseIcon="false" />
    
    
</main>
</template>

<script>
import axios from 'axios'
import SecondaryNavigation from '@/components/SecondaryNavigation'
import Footer from '@/components/Footer'


export default {

    components: {
        SecondaryNavigation,
        Footer,
    },

    data() {
        return {
            mouseX: 0,
            mouseY: 0,
            loading: true,
            contactPeople: [],
            employees: [],
        }
    },
    
    mounted() {
        
        this.getData()
    },

    methods: {
        
        getData() {
			let url = "/data/contact.json"

            this.loading = true
            
			return axios
				.get(url)
				.then(res => {
                    this.contactPeople = res.data.contactPeople
                    this.etypesEmployees = res.data.etypesEmployees
                    this.playtypeEmployees = res.data.playtypeEmployees
                    this.administrationEmployees = res.data.administrationEmployees
                    this.loading = false
                    
                    this.$emit('loaded') // Tell App data is ready
                    
                   
                    
				})
				.catch(error => {
                    throw new Error('Data Failed: ', error);
                })
        },
        
       

    },
}
</script>

<style lang="scss" scoped>

@import '../scss/variables';
@import '../scss/font-scaling';

#profile {
    @include page-padding;

    article {
        margin-left: 0;
        margin-right: 0;
        
        @media (min-width: $tablet) {
            margin-left: 12%;
            margin-right: 12%;
        }
        
        h2 {
            font-size: 20px;
            line-height: 1.2em;
            font-weight: 400;
            
            @media (min-width: $tablet) {
                font-size: 28px;
                line-height: 30px;
            }
            @media (min-width: $large-desktop) {
                line-height: 1.1em;
                @include FluidFontStart(1440, 2800, 28, 42);
            }
        }
        p {
            font-size: 13px;
            line-height: 1.4em;
            font-weight: 400;
            
            @media (min-width: $tablet) {
                font-size: 15px;
            }
            
            @media (min-width: $large-desktop) {
                line-height: 1.46em;
                @include FluidFontStart(1440, 2800, 15, 23);
            }
        }
        a {
            &:hover {
                text-decoration: underline;
            }
        }
        
        .find-us {
            margin-bottom: 8em;
            @media (min-width: $tablet) {
                margin-bottom: 24%;
            }
        }
        
        .contact-info {
            margin-bottom: 4em;
            
            @media (min-width: $phablet) {
                display: grid;
                grid-gap: 3% 6%;
                grid-template-columns: 50% 50%;
                margin-bottom: 6%;
            }
            
            .address,
            .links {
                display: block;
                margin-bottom: 1em;
                
                @media (min-width: $phablet) {
                    display: inline-block;
                    vertical-align: top;
                }
                
                p, a {
                    font-size: 28px;
                    line-height: 1.4em;
                    font-weight: 400;
                    
                    @media (min-width: $tablet) {
                        @include FluidFontStart(1024, 1600, 36, 42);
                        @include FluidFontEndless(1600, 42, .4);
                    }
                }
            }
            
            .address {
            }
        }
        .contact-persons {
            margin-bottom: 4em;
            @media (min-width: $tablet) {
                margin-bottom: 6%;
            }
            
            .contacts {
                margin-top: 1em;
                
                @media (min-width: $tablet) {
                    display: grid;
                    grid-gap: 0 3%;
                    grid-template-columns: 25% 25% 25% 25%;
                }
                
                .contact {
                    margin-bottom: 1em;
                    @media (min-width: $tablet) {
                    }
                }
            }
            
        }
        .career-internship {
            margin-bottom: 4em;
            @media (min-width: $tablet) {
                margin-bottom: 12%;
            }
            
            p {
                margin-bottom: 1em;
                @media (min-width: $tablet) {
                    margin-bottom: 0;    
                }
            }
        }
        
        .etypes-employees,
        .playtype-employees,
        .administration-employees {
            margin-bottom: 12%;
            
            h2 {
                margin-bottom: 1em;
                @media (min-width: $tablet) {
                    margin-bottom: 3%;
                }
            }
        
            .employees {
                display: grid;
                grid-gap: 0 3%;
                grid-template-columns: 50% 50%;
                
                @media (min-width: $tablet) {
                    grid-gap: 0 3%;
                    grid-template-columns: 25% 25% 25% 25%;
                }    
                .employee {
                    margin-bottom: 2em;
                    
                    p {
                        font-size: 11px;
                        @media (min-width: $tablet) {
                            @media (min-width: $tablet) {
                                @include FluidFontStart(1024, 1600, 12, 16);
                                @include FluidFontEndless(1600, 16, .4);
                            }
                        }
                    }
                }
            }
        }
        
        .administration-employees {
            margin-bottom: 24%;
        }
    }
}
</style>
